import React from "react";
import moment from "moment";
import MonthTableDay from "./MonthTableDay";

const MonthMapTable = (props) => {
  const time = moment().subtract(props.monthBefore, "months");
  let notThisMonthDays = [];
  var i;
  for (i = 0; i < time.startOf("month").day(); i++) {
    notThisMonthDays.push(
      <MonthTableDay notInMonth={true} key={props.monthBefore * 1000 + i} />
    );
  }

  const [days, uptime] = getMonthDays(time, props.data);
  return (
    <div className="month-map-table">
      <p className="month-map-table__label">
        {`${time.format("MMMM")}${
          uptime && !isNaN(uptime) ? `: ${uptime}` : ""
        }`}
      </p>
      {notThisMonthDays}
      {days.map((el) => {
        return (
          <MonthTableDay
            monthlyUptimes={props.data[el] ? props.data[el] : null}
            date={props.data[el] ? moment(el).format("MMM D") : null}
            fullDate={props.data[el] ? moment(el) : null}
            notInMonth={false}
            tooltipClass={`${props.checkId}-${el}`}
            key={moment(el).format("MMM D")}
            checkId={props.checkId}
            onDateClicked={props.onDateClicked}
            activePlanHistoryPeriod={props.activePlanHistoryPeriod}
            activePlanName={props.activePlanName}
            isShare={props.isShare}
          />
        );
      })}
    </div>
  );
};

const getMonthDays = (time, data) => {
  const tempTime = time.startOf("month");
  const days = [];
  const dayInMin = 24 * 60;
  let downtimeSum = 0;
  let totalTime = 0;
  for (var i = 0; i < time.daysInMonth() - 1; i++) {
    const day = tempTime.format("YYYY-MM-DD");
    days.push(day);
    totalTime += data[day] ? dayInMin : 0;
    downtimeSum += data[day] ? data[day].downtime_minutes : 0;
    tempTime.add(1, "days");
  }
  days.push(tempTime.format("YYYY-MM-DD"));
  const uptime = (((totalTime - downtimeSum) / totalTime) * 100).toFixed(2);
  return [days, uptime];
};

export default MonthMapTable;
